import React from 'react';

const Loader = ({ title, description, compact = false, fullScreen = false }) => {
    const loaderTitle = title || "Carregando dados. Por favor, aguarde.";
    const loaderDescription = description === undefined ? "Aguarde enquanto preparamos seu ambiente." : description;

    return (
        <div className={`${fullScreen ? 'fiscal-loading-screen' : ''}`}>
            <div className={`fiscal-loading-state ${compact ? 'is-compact' : ''}`} role="status" aria-live="polite">
                <span className="fiscal-loading-icon" aria-hidden="true">
                    <i className="mdi mdi-loading"></i>
                </span>
                <span className="fiscal-loading-copy">
                    <strong>{loaderTitle}</strong>
                    {loaderDescription && <small>{loaderDescription}</small>}
                </span>
            </div>
        </div>
    );
};

export default Loader;
